import VueRouter from "vue-router";
import _omit from "lodash/omit";

export const removeQueryParam = (router: VueRouter, key: string) => {
  const query = router.currentRoute.query;
  if (query[key]) {
    router.replace({ query: _omit(query, [key]) });
  }
};
